import React, { useState } from "react";
import { Form, Button, Card } from "react-bootstrap";
import Axios from "../axios/axios";
import TopNavBar from "../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../components/SpearParts/Layouts/TopSearchBar";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await Axios.post("/contact", formData);

      if (response.status === 200) {
        alert("Thank you for contacting us. We will get back to you soon!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        alert("Failed to send message: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Error sending message. Please try again later.");
    }
  };
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div className="New-Dashboard" style={sectionStyle}>
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <div style={{ width: "100%" }}>
          <section className="orders contact-info">
            <div className="container  ">
              {/* Logo at top */}
              <div className="text-center mb-4">
                <h3 className="text-uppercase" style={{ color: "#1A54A5" }}>
                  Contact Asia Parts Souq
                </h3>
                <p className="text-muted">
                  Email:{" "}
                  <a
                    href="mailto:info@asiapartssouq.com"
                    style={{ textDecoration: "none" }}
                  >
                    info@asiapartssouq.com
                  </a>{" "}
                  | Phone:{" "}
                  <a
                    href="tel:+971500000000"
                    style={{ textDecoration: "none" }}
                  >
                    +971 50 000 0000
                  </a>
                </p>
              </div>

              {/* Form Section */}
              <div className="row justify-content-center shadow-lg">
                <div className="col-lg-6 col-md-4 text-center mt-4 mt-md-0">
                  {" "}
                  <img src="/images/contactus.jpg" alt="Asia Parts Souq" />
                </div>
                <div className="col-lg-6 col-md-8 pt-4">
                  <Card className="shadow-lg p-4 rounded-4">
                    <p className="text-center text-muted mb-4">
                      <b>
                        Have a question? Send us a message and we’ll respond as
                        soon as possible.
                      </b>
                    </p>

                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        {/* <Form.Label>Your Name</Form.Label> */}
                        <Form.Control
                          type="text"
                          placeholder="Enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        {/* <Form.Label>Email Address</Form.Label> */}
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        {/* <Form.Label>Subject</Form.Label> */}
                        <Form.Control
                          type="text"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        {/* <Form.Label>Message</Form.Label> */}
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Write your message here..."
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <div className="text-center">
                        <Button
                          type="submit"
                          style={{
                            backgroundColor: "#1A54A5",
                            borderRadius: "25px",
                            padding: "10px 30px",
                          }}
                        >
                          Send Message
                        </Button>
                      </div>
                    </Form>
                  </Card>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
